import IconAsMaskImage from "../IconAsMaskImage";

const DoubleCheckIcon = ({ pureSvg, className, color }) => {
  const svg = (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.999"
        height="15.999"
        viewBox="0 0 15.999 15.999"
      >
        <rect width="15.999" height="15.999" fill="#841474" opacity="0" />
        <path
          d="M12.073,6.138a.667.667,0,0,0-.94.113l-4.666,6L4.18,9.464a.667.667,0,1,0-1.04.833l2.78,3.453a.7.7,0,0,0,1.073-.007l5.22-6.666a.667.667,0,0,0-.14-.94Z"
          transform="translate(-0.994 -1.998)"
          fill="#841474"
        />
        <path
          d="M18.193,6.138a.667.667,0,0,0-.94.113l-4.666,6-.407-.5-.84,1.08.733.913a.666.666,0,0,0,1.04-.007l5.22-6.666a.667.667,0,0,0-.14-.933Z"
          transform="translate(-3.781 -1.998)"
          fill="#841474"
        />
        <path
          d="M8.472,12.3l.86-1.08-.133-.16a.664.664,0,1,0-1.053.807Z"
          transform="translate(-2.666 -3.596)"
          fill="#841474"
        />
      </svg>
    </>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default DoubleCheckIcon;
